import PageView                 from '../components/collection_campaign_page/PageView';

import GetACardModal            from '../components/GetACardModal/GetACardModal';

void (window.pageView = new PageView ({
    el              : '.Carousels',
    viewId          : 'home',
    bus             : window.globalEvents,
    room            : window.OverDrive.currentRoom,
    featureManager  : window.featureManager,
    patronSettings  : window.patronSettings
}));

$(() => {
    if (window.OverDrive.showGetACardModal) {
        new GetACardModal();
    }
});
